import React from 'react';
import { PercentageOutlined } from '@ant-design/icons';
import { InputNumber } from '@clockout-dev/design-elements';
import ConfigurationCard from '../../../../common/configurationCard/ConfigurationCard';
import styles from '../styles/availableBalanceForm.module.scss';

function ThresholdCard({ value, onChange }) {
    return (
        <ConfigurationCard title="Available Balance Threshold" icon={<PercentageOutlined />}>
            <div className={styles.cardInputRow}>
                <InputNumber
                    defaultValue={value}
                    onChange={onChange}
                    min={0}
                    max={100}
                    controls={false}
                    prefix="%"
                    className={`${styles.inlineNumberInput} ${styles.percentField}`}
                />
            </div>
        </ConfigurationCard>
    );
}

export default ThresholdCard;
